// import React from 'react';
// import { useMediaQuery } from '@mui/material';

// const ResponsiveContainer = ({ children, withSidebar = true }) => {
//   const isDesktop = useMediaQuery('(min-width:900px)'); // md breakpoint
//   const isTablet = useMediaQuery('(min-width:600px) and (max-width:899px)');
//   const isMobile = useMediaQuery('(max-width:599px)');
  
//   const getMargin = () => {
//     if (!withSidebar) return '0';
//     // Only add margin on desktop when sidebar is visible
//     if (isDesktop) return '280px'; // Match your DRAWER_WIDTH
//     return '0'; // No margin on mobile/tablet
//   };
  
//   const getPadding = () => {
//     if (isMobile) return '8px';
//     if (isTablet) return '16px';
//     return '24px';
//   };
  
//   return (
//     <div style={{ 
//       minHeight: '100vh',
//       marginLeft: getMargin(),
//       paddingLeft: getPadding(),
//       paddingRight: getPadding(),
//       paddingTop: isMobile ? '16px' : '0', // Add top padding on mobile for better spacing
//       transition: 'margin-left 0.3s ease, padding 0.3s ease',
//       width: '100%',
//       maxWidth: '100vw',
//       overflow: 'hidden', // Prevent horizontal scroll
//       boxSizing: 'border-box'
//     }}>
//       {children}
//     </div>
//   );
// };

// export default ResponsiveContainer;


import React from 'react';
import { useMediaQuery } from '@mui/material';

const ResponsiveContainer = ({ children, withSidebar = true }) => {
  const isDesktop = useMediaQuery('(min-width:900px)');
  const isTablet = useMediaQuery('(min-width:600px) and (max-width:899px)');
  const isMobile = useMediaQuery('(max-width:599px)');
  
  const getStyles = () => {
    const baseStyles = {
      minHeight: '100vh',
      width: '100%',
      boxSizing: 'border-box',
      transition: 'all 0.3s ease',
    };

    if (!withSidebar) {
      return {
        ...baseStyles,
        marginLeft: '0',
        marginRight: '0',
        paddingLeft: isMobile ? '8px' : isTablet ? '16px' : '24px',
        paddingRight: isMobile ? '8px' : isTablet ? '16px' : '24px',
      };
    }

    // With sidebar - DESKTOP (centered content)
    if (isDesktop) {
      return {
        ...baseStyles,
        marginLeft: '280px', // Sidebar width
        marginRight: '0', // No right margin
        paddingLeft: '0', // No left padding (container handles it)
        paddingRight: '0', // No right padding (container handles it)
        width: 'calc(100% - 280px)', // Take remaining width after sidebar
        maxWidth: 'calc(100vw - 280px)', // Don't exceed viewport
        display: 'flex', // ✅ Use flexbox
        flexDirection: 'column', // ✅ Column layout
        alignItems: 'center', // ✅ Center children horizontally
      };
    }

    // Mobile/Tablet - no sidebar (also centered)
    return {
      ...baseStyles,
      marginLeft: '0',
      marginRight: '0',
      width: '100%',
      maxWidth: '100vw',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    };
  };
  
  return <div style={getStyles()}>{children}</div>;
};

export default ResponsiveContainer;